
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderFranchiseeShareCalculationDialog extends Serenity.EntityDialog<OrderFranchiseeShareCalculationRow, any> {
        protected getFormKey() { return OrderFranchiseeShareCalculationForm.formKey; }
        protected getIdProperty() { return OrderFranchiseeShareCalculationRow.idProperty; }
        protected getLocalTextPrefix() { return OrderFranchiseeShareCalculationRow.localTextPrefix; }
        protected getService() { return OrderFranchiseeShareCalculationService.baseUrl; }
        protected getDeletePermission() { return OrderFranchiseeShareCalculationRow.deletePermission; }
        protected getInsertPermission() { return OrderFranchiseeShareCalculationRow.insertPermission; }
        protected getUpdatePermission() { return OrderFranchiseeShareCalculationRow.updatePermission; }

        protected form = new OrderFranchiseeShareCalculationForm(this.idPrefix);

        updateInterface() {
            super.updateInterface();

            if (Authorization.hasPermission("Users:Franchisee") && !Authorization.hasPermission("Administration:Security")) {
                Serenity.EditorUtils.setReadOnly(this.form.OrderId, true);
                Serenity.EditorUtils.setReadOnly(this.form.OrderProductsId, true);
                Serenity.EditorUtils.setReadOnly(this.form.FranchiseeId, true);
            }
        }

    }
}